import React, { Component, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, NavLink, withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from "@material-ui/core/styles";
import CustomScrollbars from 'util/CustomScrollbars';
import Avatar from '@material-ui/core/Avatar';
import { RiExchangeFill } from "@react-icons/all-files/ri/RiExchangeFill";
import Drawer from '@material-ui/core/Drawer';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import IconButton from "@material-ui/core/IconButton";
import { carregaMeuContexto, abreTrocaCliente, fechaTrocaCliente, buscaClientesSelecionaveis, selecionaClienteSeguranca } from 'actions/Seguranca';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined';
import PeopleOutlinedIcon from '@material-ui/icons/PeopleOutlined';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import HomeIcon from '@material-ui/icons/Home';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const ICON_MAP = [
  { keys: ['início', 'inicio', 'home'], Icon: HomeOutlinedIcon },
  { keys: ['categor'], Icon: FolderOutlinedIcon },
  { keys: ['parceir'], Icon: PeopleOutlinedIcon },
  { keys: ['push', 'notif'], Icon: NotificationsNoneIcon },
  { keys: ['banner', 'imag'], Icon: ImageOutlinedIcon },
  { keys: ['comunic'], Icon: ChatBubbleOutlineIcon },
  { keys: ['usuár', 'usuario', 'client', 'pessoa'], Icon: PersonOutlinedIcon },
];

function getNavIcon(name, color) {
  const n = (name || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const found = ICON_MAP.find(m => m.keys.some(k => n.includes(k)));
  const Icon = found ? found.Icon : DashboardOutlinedIcon;
  return <Icon style={{ fontSize: 20, color, flexShrink: 0 }} />;
}

const navLinkBase = {
  display: 'flex',
  alignItems: 'center',
  padding: '11px 14px',
  borderRadius: 10,
  textDecoration: 'none',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 500,
  fontSize: 14,
  gap: 12,
  transition: 'background 0.15s',
};

function NavItem({ to, label, icon, pathname }) {
  const active = pathname === to || pathname.startsWith(to + '/');
  const color = active ? 'white' : '#666';
  return (
    <li style={{ margin: '3px 10px', listStyle: 'none' }}>
      <NavLink to={to} style={{ ...navLinkBase, backgroundColor: active ? '#05B59D' : 'transparent', color }} activeStyle={{}}>
        {icon ? icon(color) : getNavIcon(label, color)}
        <span style={{ flex: 1 }}>{label}</span>
        {active && <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: 'white', flexShrink: 0 }} />}
      </NavLink>
    </li>
  );
}

function NavGroup({ label, icon, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <li style={{ listStyle: 'none' }}>
      <div
        onClick={() => setOpen(o => !o)}
        style={{ ...navLinkBase, margin: '3px 10px', color: '#666', cursor: 'pointer', userSelect: 'none' }}
      >
        {icon ? icon('#666') : getNavIcon(label, '#666')}
        <span style={{ flex: 1 }}>{label}</span>
        <span style={{
          display: 'inline-flex',
          transition: 'transform 0.2s ease',
          transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
          flexShrink: 0,
        }}>
          <ChevronRightIcon style={{ fontSize: 18, color: '#aaa' }} />
        </span>
      </div>
      {open && (
        <ul style={{ paddingLeft: 12, margin: 0 }}>
          {children}
        </ul>
      )}
    </li>
  );
}

const StyledCard = withStyles({
  root: {
    padding: 8,
    backgroundColor: 'red',
    border: '1px solid #F4F4F7',
    boxSizing: 'border-box',
    borderRadius: '8px',
    height: 56
  },
  "&.MuiCardHeader-root": {
    padding: 8,
    backgroundColor: 'yellow'
  },
})(Card);

const styles = theme => ({
  input: {
    fontSize: 19,
    fontWeight: 400,
    fontFamily: 'Montserrat, sans-serif',

    "&::placeholder": {
      textOverflow: "ellipsis !important",
      color: "gray",
      fontSize: 20,
      lineHeight: 24,
      fontWeight: 400,
      fontFamily: 'Montserrat, sans-serif'
    },
  },

  root: {
    "&.MuiCardHeader-root": {
      padding: 8,
      backgroundColor: 'red'
    },
  }

});

class SidenavContent extends Component {
  constructor() {
    super();
    this.state = { alternarCliente: false, openPush: false, openPartner: false, openBanner: false }
  }

  componentDidMount() {
    this.handleTeste();

    // Antes era iniciaDefinicoes() (sagas/Inicio.js, backend legado). Migrado pra
    // GET /me da Uzerpass.Seguranca — buscado de novo aqui pra sobreviver a F5 (o
    // contexto não é persistido em localStorage, é sempre buscado fresco). Ver
    // docs/plano-integracao-api-seguranca.md.
    if (!this.props.seguranca || !this.props.seguranca.carregado) {
      this.props.carregaMeuContexto();
    }
    this.props.buscaClientesSelecionaveis();
  }

  componentDidUpdate() {
    this.handleTeste();
  }

/*   componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`;// get current path

    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {

        const parentLiEle = that.closest(this, 'li');
        if (menuLi[i].classList.contains('menu') && parentLiEle !== null) {
          event.stopPropagation();

          if (menuLi[i].classList.contains('open')) {
            menuLi[i].classList.remove('open', 'active');
          } else {
            menuLi[i].classList.add('open', 'active');
          }
        } else {
          for (let j = 0; j < menuLi.length; j++) {
            const parentLi = that.closest(this, 'li');
            if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
              menuLi[j].classList.remove('open');
            } else {
              if (menuLi[j].classList.contains('open')) {
                menuLi[j].classList.remove('open');
              } else {
                menuLi[j].classList.add('open');
              }
            }
          }
        }
      }
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  } */

  handleTeste() {
  const { history } = this.props;
  const that = this;
  const pathname = `${history.location.pathname}`;// get current path

  const menuLi = document.getElementsByClassName('menu');
  for (let i = 0; i < menuLi.length; i++) {
    menuLi[i].onclick = function (event) {

      const parentLiEle = that.closest(this, 'li');
      if (menuLi[i].classList.contains('menu') && parentLiEle !== null) {
        event.stopPropagation();

        if (menuLi[i].classList.contains('open')) {
          menuLi[i].classList.remove('open', 'active');
        } else {
          menuLi[i].classList.add('open', 'active');
        }
      } else {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, 'li');
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
            menuLi[j].classList.remove('open');
          } else {
            if (menuLi[j].classList.contains('open')) {
              menuLi[j].classList.remove('open');
            } else {
              menuLi[j].classList.add('open');
            }
          }
        }
      }
    }
  }


  const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
  try {
    const activeNav = this.closest(activeLi, 'ul'); // select closest ul
    if (activeNav.classList.contains('sub-menu')) {
      this.closest(activeNav, 'li').classList.add('open');
    } else {
      this.closest(activeLi, 'li').classList.add('open');
    }
  } catch (error) {

  }
}

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`;// get current path

    const allMenuLis = document.querySelectorAll('.nav-menu li');
    allMenuLis.forEach(li => li.classList.remove('open'));

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] === 'function') {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {

    }

    return null;
  }

  handleOlaTeste() {
    alert('Inicio');
    this.handleTeste();
    alert('Fim');
  }

  handleAlternarCliente = (val) => {
    this.setState({ alternarCliente: val });
  }

  // Substitui ObtemMenuUsuario/ObtemRotasUsuario (que liam configuracao.menus do backend
  // legado). A árvore de GET /me da Uzerpass.Seguranca já vem filtrada por permissão — só
  // precisa desenhar, recursivamente (o legado só tinha 2 níveis; a API nova permite
  // n níveis, ver docs/plano-integracao-api-seguranca.md §2.4).
  renderItensMenu(itens, pathname) {
    return (itens || [])
      .filter(item => item.exibirNoMenu !== false)
      .map(item => {
        if (item.itens && item.itens.length > 0) {
          return (
            <NavGroup key={item.id} label={item.nome}>
              {this.renderItensMenu(item.itens, pathname)}
            </NavGroup>
          );
        }

        if (!item.rota) return null;

        const LABEL_OVERRIDES = {
          '/app/verificacaoIdentidade': 'Verificação da Conta',
        };
        const label = LABEL_OVERRIDES[item.rota] || item.nome;
        return <NavItem key={item.id} to={item.rota} label={label} pathname={pathname} />;
      });
  }

  render() {

    const seguranca = this.props.seguranca || {};
    const modulos = seguranca.modulos || [];
    const usuario = seguranca.usuario || {};
    const adm = !!usuario.ehAdministradorGlobal;
    const ehMulti = !!seguranca.multiCliente;
    const { classes } = this.props;

    const encontraModulo = (codigo) => modulos.find(m => m.codigo === codigo);

    // Cliente ativo: a API só devolve o id (ClienteAtivoDto); nome/imagem vêm da lista de
    // clientes selecionáveis (GET /me/clientes, já resolvida via Dapper no banco legado —
    // ver docs/troca-de-cliente.md na Uzerpass.Seguranca). "imagem" já chega como data URI
    // completa (data:image/...;base64,...), sem o tratamento de string que o legado fazia.
    const clientesSelecionaveis = seguranca.clientesSelecionaveis || [];
    const clienteAtivoInfo = seguranca.clienteAtivo
      ? clientesSelecionaveis.find(c => c.id === seguranca.clienteAtivo.id)
      : null;
    const clienteFixo = !!clienteAtivoInfo;
    const imagemClienteAtivo = clienteAtivoInfo ? clienteAtivoInfo.imagem : null;
    const trocaClienteAberta = !!seguranca.trocaClienteAberta;

    return (
      <CustomScrollbars className=" scrollbar">

        {clienteFixo && (
          <NavLink to="/app/inicio" style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
            <Avatar
              src={imagemClienteAtivo || require("assets/images/no-image.jpg")}
              style={{ width: 90, height: 90, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
            />
          </NavLink>
        )}

        <div style={{ color: '#222224', textAlign: 'center', width: '100%', paddingLeft: 10, paddingRight: 10, paddingTop: 8, fontWeight: 600, fontSize: 13, fontFamily: 'Montserrat, sans-serif' }}>
          {clienteAtivoInfo ? clienteAtivoInfo.nome : ''}
        </div>

        {(adm || ehMulti) && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 4 }}>
            <button
              onClick={() => this.props.abreTrocaCliente()}
              style={{
                border: '1.5px solid #05B59D',
                borderRadius: 20,
                padding: '6px 22px',
                background: 'transparent',
                color: '#05B59D',
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 500,
                fontSize: 13,
                cursor: 'pointer',
                letterSpacing: 0.3,
              }}
            >
              Alterar cliente
            </button>
          </div>
        )}

        <Drawer anchor="left" open={trocaClienteAberta} onClose={() => this.props.fechaTrocaCliente()}>

          {
            (clienteFixo) && (

              imagemClienteAtivo ?

                <Avatar variant='square' style={{ width: 200, height: 200, marginLeft: 'auto', marginRight: 'auto', marginTop: 15 }} src={imagemClienteAtivo} />
                :
                <Avatar variant='rounded' style={{ width: 250, height: 200 }} src={require("assets/images/no-image.jpg")} />
            )
          }

          {
            <Fragment>
              <div style={{ color: '#222224', textAlign: 'center', width: '375px', fontWeight: 500, paddingLeft: 10, paddingRight: 10, paddingTop: 5, fontFamily: 'Montserrat, sans-serif' }}>{clienteAtivoInfo ? clienteAtivoInfo.nome : ''}</div>

              <Divider style={{ marginBottom: 15, marginTop: 10 }} light />


              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <div style={{ color: '#3A3A3D', fontWeight: 400, fontSize: '16px', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.15px' }}>Selecione um cliente</div>
                <TextField
                  variant="filled"
                  placeholder="Pesquisar..."
                  value={seguranca.buscaCliente || ''}
                  onChange={(e) => this.props.buscaClientesSelecionaveis(e.target.value)}
                  margin="normal"
                  fullWidth={true}
                  style={{ lineHeight: '24px', marginTop: '10px', marginBottom: '10px', backgroundColor: '#00000000' }}
                  InputProps={{
                    classes: {
                      input: classes.input
                    },
                    endAdornment: (
                      <InputAdornment>
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                />

                {
                  clientesSelecionaveis.map(n => {
                    return (<Fragment key={`key${n.id}`}>
                      <div onClick={() => { this.props.selecionaClienteSeguranca(n.id); }} style={{ cursor: 'pointer' }}>
                        <Card style={{ border: '1px solid #F4F4F7', boxSizing: 'border-box', borderRadius: '8px', height: 56, marginBottom: 10 }}>
                          <CardHeader style={{ padding: 8 }}
                            avatar={
                              n.imagem ?
                                <Avatar style={{ width: 40, height: 40 }} src={n.imagem} /> :
                                <Avatar style={{ width: 40, height: 40 }} src={require("assets/images/no-image.jpg")} />
                            }
                            action={
                              <ChevronRightIcon style={{ marginTop: 17, color: '#3A3A3D' }} />
                            }
                            title={n.nome}
                          />
                        </Card>
                      </div>
                    </Fragment>);
                  })}
              </div>

            </Fragment>
          }


        </Drawer>

        <ul className="nav-menu" style={{ paddingTop: 8, paddingBottom: 8 }}>

          {(() => {
            const pathname = this.props.history.location.pathname;
            const isComunicacoes = ['/app/bannersClubeVantagens', '/app/push', '/app/banners', '/app/categoriasParceiros', '/app/parceiros', '/app/noticias', '/app/videos', '/app/futebol'].some(p => pathname.startsWith(p));
            const emPrincipal = pathname.startsWith('/app/validacaoPerfil') || pathname.startsWith('/app/verificacaoIdentidade') || pathname.startsWith('/app/trocaFoto');

            if (emPrincipal) {
              const moduloValidacao = encontraModulo('validacao-perfil');
              return this.renderItensMenu(moduloValidacao ? moduloValidacao.menus : [], pathname);
            }

            if (isComunicacoes) {
              const moduloComunicacao = encontraModulo('comunicacao');
              return this.renderItensMenu(moduloComunicacao ? moduloComunicacao.menus : [], pathname);
            }

            const moduloBackoffice = encontraModulo('backoffice');
            const itensBackoffice = moduloBackoffice ? moduloBackoffice.menus : [];

            // Antes replicava aqui os itens de Comunicação pra admins (comportamento do
            // legado). Removido: docs/modulos-menus-seed.md (Uzerpass.Seguranca) registra a
            // decisão de 2026-09-28 de não duplicar mais — cada módulo mostra só os próprios
            // itens, sem duplicação manual no frontend.
            return this.renderItensMenu(itensBackoffice, pathname);
          })()}

        </ul>
      </CustomScrollbars>
    );
  }
}

SidenavContent.propTypes = {
  classes: PropTypes.object.isRequired,
};


const mapStateToProps = ({ auth, seguranca }) => {
  const { perfil } = auth;
  return { perfil, seguranca };
};

export default connect(mapStateToProps, { carregaMeuContexto, abreTrocaCliente, fechaTrocaCliente, buscaClientesSelecionaveis, selecionaClienteSeguranca })(withRouter(withStyles(styles)(SidenavContent)));
